module.exports = __webpack_public_path__ + "media/images/flags/4x3/kaz-64e40aca1abb71a9a6e3850cd4304049.svg";